import { useEffect } from "react";
import { useI18n } from "../../i18n/localization";
import { createRingtone } from "../../services/ringtone";

// Incoming call — modal shown to the traffic officer (docs/design/05-uiux-spec.md §3.4).
export function IncomingCall({
  fromName,
  onAccept,
  onDecline
}: {
  fromName: string | null;
  onAccept: () => void;
  onDecline: () => void;
}) {
  const { t, dir } = useI18n();
  // Ring while this modal is mounted. It is rendered only on the traffic-officer side for an
  // active invite, and unmounts on accept/decline/call-end, so the cleanup stops the tone on
  // every exit. The field/caller side never mounts this component, so it never rings there.
  // createRingtone is fully guarded: a blocked/unsupported AudioContext degrades to silence.
  useEffect(() => {
    const ringtone = createRingtone();
    ringtone.start();
    return () => ringtone.stop();
  }, []);

  return (
    <div style={overlay}>
      <div style={modal} dir={dir}>
        <div style={{ fontSize: 17, color: "#14305f", marginBottom: 6 }}>{t.call.incomingTitle}</div>
        {fromName && <div style={{ fontSize: 15, color: "#1e2a3a", marginBottom: 8 }}>{fromName}</div>}
        <div style={{ fontSize: 12, color: "#dc2626", marginBottom: 20 }}>● {t.banner.recordingOn}</div>
        <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
          <button onClick={onAccept} style={okBtn}>{t.call.accept}</button>
          <button onClick={onDecline} style={dangerBtn}>{t.call.decline}</button>
        </div>
      </div>
    </div>
  );
}

const overlay: React.CSSProperties = {
  position: "fixed", inset: 0, background: "rgba(15,30,58,.55)",
  display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Segoe UI, Arial, sans-serif"
};
const modal: React.CSSProperties = {
  background: "#fff", borderRadius: 12, padding: "28px 36px", textAlign: "center", boxShadow: "0 12px 40px rgba(0,0,0,.3)"
};
const okBtn: React.CSSProperties = {
  background: "#15803d", color: "#fff", border: "none", borderRadius: 6, padding: "8px 22px", fontSize: 14, cursor: "pointer"
};
const dangerBtn: React.CSSProperties = {
  background: "#dc2626", color: "#fff", border: "none", borderRadius: 6, padding: "8px 22px", fontSize: 14, cursor: "pointer"
};
